import React, { useContext } from 'react';
import { TextField } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { RightsContext } from 'providers/RightsContext';

const FolderExternalChecksItemContentComponent = ({ check, onResultChange }) => {
  const [t] = useTranslation();
  const { readOnlyFull, decisionExternalChecksWrite } = useContext(RightsContext);

  return (
    <TextField
      multiline
      label={t('Folder.VerificationsSummary.Result')}
      fullWidth
      variant={'outlined'}
      value={check.result}
      disabled={readOnlyFull || !decisionExternalChecksWrite}
      onChange={onResultChange}
    />
  );
};

FolderExternalChecksItemContentComponent.propTypes = {
  check: PropTypes.object.isRequired,
  onResultChange: PropTypes.func.isRequired
};

export default FolderExternalChecksItemContentComponent;
